import { useState } from "react";
// import ToastAlarm from "../Components/ToastAlarm";
import "../Styles/global.css";

const LayoutModal = ({ Modal }) => {
  return (
    <div
      className="page-wrapper center"
      style={{
        backgroundColor: "rgba(176,176,176, 0.4)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 100,
      }}
    >
      {/* <ToastAlarm
        message={localStorage.getItem("toast_message")}
        setToast={setToast}
        type={localStorage.getItem("toast_type")}
      /> */}
      {Modal}
    </div>
  );
};

export default LayoutModal;
